:host {
  --background-color: #{$colorGrey20};
  --icon-color: #{$colorInfo70};
  --close-color: #{$colorGrey90};
  --label-color: #{$colorInfo70};
  --description-color: #{$colorGrey90};

  &[type="success"] {
    --label-color: #{$colorSuccess70};
    --icon-color: #{$colorSuccess70};
    --background-color: #{$colorSuccess20};
  }

  &[type="warning"] {
    --label-color: #{$colorWarning90};
    --icon-color: #{$colorWarning90};
    --background-color: #{$colorWarning20};
  }

  &[type="error"] {
    --label-color: #{$colorError70};
    --icon-color: #{$colorError70};
    --background-color: #{$colorError20};
  }
}

.stzh-message {
  position: relative;
  display: flex;
  box-shadow: $boxShadowMessage;
  background-color: var(--background-color);
  border-radius: #{$buttonBorderRadius};

  &__content {
    @include spaceCurve('padding-top', 'regular');
    @include spaceCurve('padding-bottom', 'regular');
    @include spaceCurve('padding-right', 'medium');
    @include spaceCurve('gap', 'small');
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-left: space('medium');

    @include mq($from: small) {
      flex-direction: row;
      align-items: flex-start;
    }

    @include mq($from: medium) {
      padding-left: space('large');
    }
  }

  &__icon-wrapper {
    display: flex;
    flex-shrink: 0;
  }

  &__icon {
    --size: #{iconSize('large')};
    color: var(--icon-color);
  }

  &__text-wrapper {
    @include mq($from: small) {
      flex-grow: 1;
    }
  }

  &__label {
    @include font('title');
    @include fontCurve('h4', 'heading');
    color: var(--label-color);

    &:not(:empty) {
      margin-bottom: var(--stzh-space-xsmall);
    }
  }

  &__description {
    @include fontCurve('p1');
    color: var(--description-color);
  }

  &__description:not(:empty) + &__link:not(:empty) {
    @include spaceCurve('margin-top', 'small');
  }

  &__close[variant="tertiary"] {
    --color: var(--close-color);

    position: absolute;
    top: 0;
    right: 0;
  }

  /* Only label variant */

  &:has(#{&}__description:empty):has(#{&}__link:empty) &__label:not(:empty) {
    margin-top: space('xxsmall');
    margin-bottom: 0;
  }
}
